import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { HealthAndSafetySettings } from '../../models/serializable/health-and-safety-settings.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class HealthAndSafetyComponent extends Component {
  static readonly TYPE_ID: string = '10439f7981824b6ba4de03d0806e5ccb';

  constructor(
    public readonly settings: HealthAndSafetySettings,
  ) {
    super();
  }

  get $typeId(): string {
    return HealthAndSafetyComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): HealthAndSafetyComponent {
    return new HealthAndSafetyComponent(
        context.fromData<HealthAndSafetySettings>(MapUtils.getRaw(map, 'settings') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'settings': context.toData(this.settings),
    };
  }

  clone(): this {
    return new HealthAndSafetyComponent(
        this.settings.clone(),
    ) as this;
  }

  isSame(other: HealthAndSafetyComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.settings, this.settings);
  }
}

export class HealthAndSafetyComponentBuilder extends DataModelBuilder<HealthAndSafetyComponent> {
  build(context: SerializationContext, map: SerializedData): HealthAndSafetyComponent {
    return HealthAndSafetyComponent.fromMap(context, map);
  }
}
